import {
  CopyButton,
  IDebugMenuEntity,
  OneMenuInfo,
  PluInfo,
  StoreInfo,
  useDebugMenuItemData,
} from 'components/debug-tool';
import { Typography } from 'components/ui';
import { LoyaltyOffer, LoyaltyReward, isLoyaltyOffer } from 'state/loyalty/types';
import { blockContentToPlainText } from 'utils/sanity';

interface IIncentiveDebugProps {
  incentive: LoyaltyOffer | LoyaltyReward;
}

const IncentiveEntityDebug = ({ entity, label }: { entity: IDebugMenuEntity; label: string }) => {
  const debugData = useDebugMenuItemData({ entity, entryId: entity._id });

  return (
    <>
      <Typography variant="headerTwo" mb="$2">
        {label}
      </Typography>
      {debugData.isOneMenu ? (
        <OneMenuInfo
          entryId={debugData.oneMenuEntryId}
          posIdsConfiguration={debugData?.posIdsConfiguration}
          price={debugData.price}
          priceStatus={debugData.priceStatus}
        />
      ) : debugData.vendorConfig ? (
        <PluInfo vendorConfig={debugData.vendorConfig} />
      ) : (
        <Typography variant="copyOne" mb="$2">
          Vendor configuration not found
        </Typography>
      )}
    </>
  );
};

export const IncentiveDebug: React.FC<IIncentiveDebugProps> = ({ incentive }) => {
  const incentiveType = isLoyaltyOffer(incentive) ? 'Offer' : 'Reward';
  const incentiveName = isLoyaltyOffer(incentive)
    ? blockContentToPlainText(incentive.name?.localeRaw)
    : incentive.name?.locale;
  const headerText = `${incentiveType}: ${incentiveName}`;
  const loyaltyEngineId = incentive.loyaltyEngineId ?? 'Not Available';

  const [benefit] = incentive.incentives ?? [];

  return (
    <>
      <Typography variant="headerOne">{headerText}</Typography>
      <StoreInfo />
      <IncentiveEntityDebug
        entity={incentive as IDebugMenuEntity}
        label={`${incentiveType} PLU:`}
      />
      {benefit && '_id' in benefit ? (
        <IncentiveEntityDebug entity={benefit as IDebugMenuEntity} label="Benefit PLU:" />
      ) : null}
      <CopyButton label={`Engine ID: ${loyaltyEngineId}`} textToCopy={loyaltyEngineId} />
    </>
  );
};
